// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import HydrantMapItemIconModel from '../../model/hydrant-map-item-icon-model';
import HydrantMapItemIconDTO from '../dto/hydrant-map-item-icon-dto';
import dtoSchema from '../schemas/hydrant-map-item-icon-schema';

export default abstract class HydrantMapItemIconModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<HydrantMapItemIconDTO>) {
    super();
    if (data) {
      this.iconType = data.iconType ?? undefined;
      this.iconColor = data.iconColor ?? undefined;
    }
  }
  /**
  */
  iconType?: string;
  /**
  */
  iconColor?: string;

  static toModel(dto: DeepPartial<HydrantMapItemIconDTO>): HydrantMapItemIconModel;
  static toModel(dto: DeepPartial<HydrantMapItemIconDTO> | undefined | null): HydrantMapItemIconModel | undefined;
  static toModel(dto: DeepPartial<HydrantMapItemIconDTO> | undefined | null): HydrantMapItemIconModel | undefined {
    return dto ? new HydrantMapItemIconModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<HydrantMapItemIconModel> | HydrantMapItemIconModel): HydrantMapItemIconDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      iconType: unwrapped.iconType,
      iconColor: unwrapped.iconColor,
    } as HydrantMapItemIconDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for HydrantMapItemIconModel, can not map to HydrantMapItemIconDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
